import { Hidden, useMediaQuery, useTheme } from '@material-ui/core';
import {
  EditProfileSideInfoActions,
  EditProfileSideInfoContainer,
} from '../EditProfileSideInfo/EditProfileSideInfo.styles';
import { EditProfileContainer, EditProfileCustomSkeleton } from '../../EditProfile.styles';

const EditProfileSkeletons = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <EditProfileContainer>
      <EditProfileSideInfoContainer>
        <Hidden lgUp>
          <EditProfileCustomSkeleton variant="rect" style={{ width: '100%', height: 151, borderRadius: '8px' }} />
          <EditProfileSideInfoActions>
            <EditProfileCustomSkeleton
              width={matches ? 200 : '100%'}
              height={matches ? '100%' : '50px'}
              style={{ borderRadius: 8 }}
              variant="rect"
            />
            <EditProfileCustomSkeleton
              width={'100%'}
              height={matches ? '100%' : '50px'}
              style={{ borderRadius: 8 }}
              variant="rect"
            />
          </EditProfileSideInfoActions>
        </Hidden>
        <Hidden mdDown>
          <div style={{ display: 'grid', gap: 10, width: '300px' }}>
            <div style={{ aspectRatio: '95/132', width: '100%', height: 'auto' }}>
              <EditProfileCustomSkeleton width={'100%'} height={'100%'} variant="rect" />
            </div>
            <EditProfileCustomSkeleton width={'100%'} height={'200px'} variant="rect" />
            <EditProfileCustomSkeleton width={'100%'} height={'50px'} variant="rect" />
            <EditProfileCustomSkeleton width={'100%'} height={'50px'} variant="rect" />
          </div>
        </Hidden>
      </EditProfileSideInfoContainer>
      <div style={{ width: '100%', display: 'grid', height: '100%', gap: 10 }}>
        <EditProfileCustomSkeleton width={'100%'} height={50} variant="rect" />
        <EditProfileCustomSkeleton variant="rect" width={'100%'} height={150} />
        <EditProfileCustomSkeleton variant="rect" width={'100%'} height={150} />
        <EditProfileCustomSkeleton variant="rect" width={'100%'} height={150} />
        <EditProfileCustomSkeleton variant="rect" width={'100%'} height={150} />
      </div>
    </EditProfileContainer>
  );
};

export default EditProfileSkeletons;
